/* eslint-disable */
import { useTranslation as useUiTranslation } from "react-i18next";
import React from 'react';
import { useSelector } from 'react-redux';

export const ComponentToPrint = React.forwardRef((props, ref) => {
  const { t: uiT } = useUiTranslation();
    return (
        <div ref={ref} className="" dir='rtl'>
            {props.data.map((d, index) => (
                <div
                    key={index}
                    style={{
                        pageBreakAfter: props.data.length - 1 === index ? 'avoid' : 'always',
                        fontFamily: 'Arial',
                        fontSize: '18px',
                        lineHeight: '1.8',
                        maxWidth: '800px',
                        margin: '0 auto',
                        padding: '20px'
                    }}
                >
                    {/* Logo */}
                    <div className='text-center mb-4'>
                        <img src="/Logo.png" alt={uiT("ui.logo")} style={{
                            height: '80px',
                            marginBottom: '20px'
                        }} />
                    </div>

                    {/* En-tête */}
                    <div className='d-flex justify-content-between align-items-center border-bottom pb-4 mb-4' style={{
                        paddingBottom: '20px',
                        marginBottom: '20px'
                    }}>
                        <div style={{ width: '30%' }}>
                            <p className='mb-2'><strong>{uiT("ui.trackingLabel")}</strong> {d?.tracking || '---------'}</p>
                            <p className='mb-2'><strong>{uiT("ui.weightLabel")}</strong> {d?.weight || '0.00'} KG</p>
                        </div>
                        <div className='text-center' style={{ width: '40%' }}>
                            <h3 className='mb-1' style={{ fontSize: '24px', fontWeight: 'bold' }}>{uiT("ui.shippingLabel")}</h3>
                            <p className='mb-0' style={{ fontSize: '18px' }}>{d?.stopdeskDelivery ? uiT("ui.officeDelivery") : uiT("ui.homeDelivery")}</p>
                        </div>
                        <div className='text-end' style={{ width: '30%' }}>
                            <p className='mb-2'><strong>{uiT("ui.amountLabel")}</strong> {d?.total} {uiT("currency")}</p>
                        </div>
                    </div>

                    {/* Sections container */}
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        gap: '30px',
                        marginBottom: '20px'
                    }}>
                        {/* Destinataire */}
                        <div className='mb-4' style={{
                            backgroundColor: '#f8f9fa',
                            padding: '15px',
                            borderRadius: '8px'
                        }}>
                            <h4 className='mb-3' style={{
                                textDecoration: 'underline',
                                fontSize: '20px',
                                textAlign: 'center',
                                marginBottom: '15px'
                            }}>{uiT("ui.recipientLabel")}</h4>
                            <p><strong>{uiT("Products.Table.expand.info.name")}</strong> {d?.name}</p>
                            <p><strong>{uiT("ui.phoneLabel")}</strong> {d?.phone}</p>
                            <p><strong>{uiT("ui.stateLabel")}</strong> {d?.state}</p>
                            <p><strong>{uiT("ui.communeLabel")}</strong> {d?.commune}</p>
                            <p><strong>{uiT("ui.addressLabel")}</strong> {d?.address}</p>
                        </div>

                        {/* Expéditeur */}
                        <div className='mb-4' style={{
                            backgroundColor: '#f8f9fa',
                            padding: '15px',
                            borderRadius: '8px'
                        }}>
                            <h4 className='mb-3' style={{
                                textDecoration: 'underline',
                                fontSize: '20px',
                                textAlign: 'center',
                                marginBottom: '15px'
                            }}>{uiT("ui.senderLabel")}</h4>
                            <p><strong>{uiT("Products.Table.expand.info.name")}</strong> {props.account?.name}</p>
                            <p><strong>{uiT("ui.phoneLabel")}</strong> {props.account?.phone}</p>
                        </div>
                    </div>

                    {/* Produit */}
                    <div className='mb-4' style={{
                        backgroundColor: '#f8f9fa',
                        padding: '15px',
                        borderRadius: '8px',
                        marginBottom: '20px'
                    }}>
                        <h4 className='mb-3' style={{
                            textDecoration: 'underline',
                            fontSize: '20px',
                            textAlign: 'center',
                            marginBottom: '15px'
                        }}>{uiT("ui.productLabel")}</h4>
                        <p><strong>{uiT("Products.Table.expand.info.name")}</strong> {d.nameproduct || props.products?.find(p => p.id === d.productId)?.name || '---'}</p>
                        <p><strong>{uiT("Products.Table.expand.info.quantity")}</strong> {d.qty}</p>
                        <p><strong>{uiT("Products.Table.expand.info.price")}</strong> {d.total - d.deliveryPrice} {uiT("currency")}</p>
                    </div>

                    {/* Facture */}
                    <div className='mb-4 border-top pt-4' style={{
                        paddingTop: '20px',
                        marginBottom: '20px',
                        backgroundColor: '#f8f9fa',
                        padding: '15px',
                        borderRadius: '8px'
                    }}>
                        <h4 className='mb-3' style={{
                            textDecoration: 'underline',
                            fontSize: '20px',
                            textAlign: 'center',
                            marginBottom: '15px'
                        }}>{uiT("ui.invoiceLabel")}</h4>
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr',
                            gap: '10px'
                        }}>
                            <div>
                                <p><strong>{uiT("ui.shippingPriceLabel")}</strong> {d.deliveryPrice} {uiT("currency")}</p>
                                <p><strong>{uiT("ui.orderValueLabel")}</strong> {d.total - d.deliveryPrice} {uiT("currency")}</p>
                            </div>
                            <div style={{ textAlign: 'left' }}>
                                <p><strong>{uiT("ui.totalLabel")}</strong> {d.total} {uiT("currency")}</p>
                            </div>
                        </div>
                    </div>

                    {/* Déclaration */}
                    <div className='border-top pt-3' style={{
                        paddingTop: '20px',
                        backgroundColor: '#f8f9fa',
                        padding: '15px',
                        borderRadius: '8px'
                    }}>
                        <p style={{
                            fontSize: '16px',
                            textAlign: 'center',
                            lineHeight: '1.6'
                        }}>
                            {uiT("ui.senderDeclaration")} {props?.account?.name} {uiT("ui.shippingDeclaration")}
                        </p>
                    </div>

                    {/* Footer */}
                    <div className='text-center mt-4' style={{
                        marginTop: '30px',
                        fontSize: '14px',
                        color: '#6c757d'
                    }}>
                        <p>{uiT("ui.thanks")}</p>
                    </div>
                </div>
            ))}
        </div>
    );
});